import { remove } from '@/backend/api'
import type { MembershipPayload } from '@/store/types/MembershipPayload'
import { isErrorResponse } from '@/backend/error/types'
import { errorMessages, parseError } from '@/backend/error'
import type { ApiResult } from '@/backend/darwin/types'

/**
 * Delete a membership
 */
export const deleteTeamMembership = async (
  membershipId: MembershipPayload['id'],
): Promise<ApiResult<MembershipPayload>> => {
  try {
    const response = await remove<MembershipPayload>(`memberships/${membershipId}`)
    return { data: response.data, ok: true }
  } catch (error) {
    if (!isErrorResponse(error)) {
      throw error
    }
    return {
      ...parseError(error, errorMessages.TEAM_MEMBERS_DELETE_MEMBERSHIP, { membershipId }),
      ok: false,
    }
  }
}
